import { SubmitHandler, useForm } from 'react-hook-form';

import { ArrowRightIcon, BuildingStorefrontIcon } from '@heroicons/react/24/outline';

import useServerBusiness from '../../api/useServerBusiness';
import useServer from '../../api/useServerMain';
import Button from '../../components/misc/Button';
import GenericImageDrop from '../../components/misc/Images/GenericImageDrop';
import MultipleDrop from '../../components/misc/Images/MultipleDrop';
import { useAppSelector } from '../../store/hooks';
import { cleanObj } from '../../utils/helpers';

const StoreGalery = () => {
  const { denyRoles } = useServer()

  const { control, handleSubmit } = useForm()
  const { business } = useAppSelector((state) => state.init)
  const { editBusiness, isFetching } = useServerBusiness()

  const onSubmit: SubmitHandler<Record<string, string | boolean | number>> = (
    data
  ) => {
    editBusiness(cleanObj(data))
  }

  return (
    <div className="relative rounded-md border border-slate-300 bg-white p-3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex justify-end">
          <a
            className="flex items-center justify-end gap-2 py-2 text-slate-500"
            href={`https://sinterceros.com`}
            target="_blank"
          >
            Ir a la tienda
            <ArrowRightIcon className="h-4 text-slate-500" />
            <BuildingStorefrontIcon className="h-5 text-slate-500" />
          </a>
        </div>

        <div className="h-full w-full overflow-auto rounded-lg border border-gray-400 p-2 scrollbar-none">
          <GenericImageDrop
            name="bannerId"
            control={control}
            className="flex h-64 cursor-pointer items-center justify-center overflow-hidden rounded-lg border border-gray-400"
            previewDefault={business?.banner?.src}
            previewHash={business?.banner?.blurHash}
          />

          <div className="relative -top-20 left-6">
            <GenericImageDrop
              name="logoId"
              control={control}
              className="z-10 h-40 w-40 cursor-pointer overflow-hidden rounded-full border border-gray-400 bg-gray-100"
              previewDefault={business?.logo?.src}
              previewHash={business?.logo?.blurHash}
            />
          </div>

          <MultipleDrop
            className="rounded border border-dashed border-gray-400 p-2"
            name="images"
            control={control}
            previewDefault={business?.images.map((item) => ({
              id: item.id,
              src: item.src,
              hash: item.blurHash,
            }))}
          />
        </div>
        <div className="flex justify-end py-2">
          <Button
            type="submit"
            color="slate-500"
            name="Actualizar"
            disabled={isFetching || !denyRoles(['AUDITOR'])}
            loading={isFetching}
          />
        </div>
      </form>
    </div>
  )
}

export default StoreGalery
